import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import propTypes from '../../../node_modules/prop-types/index.js';
import Icon from '../Icon/Icon.js';
import { TOOLTIP_VARIANT } from './constants.js';

var _excluded = ["variant", "isShowTooltip", "theme"];

var DefaultIcon = function DefaultIcon(_ref) {
  var variant = _ref.variant,
      isShowTooltip = _ref.isShowTooltip,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, _excluded);

  if (variant === TOOLTIP_VARIANT.PRIMARY && !isShowTooltip) {
    return /*#__PURE__*/React.createElement(Icon, _extends({
      manulifeName: "question_withcircle_filled",
      fill: theme.colorPalette.neutralColors.light.shade_white,
      secondaryColor: theme.colorPalette.primaryColors.main.shade_default
    }, rest));
  }

  if (variant === TOOLTIP_VARIANT.SECONDARY && !isShowTooltip) {
    return /*#__PURE__*/React.createElement(Icon, _extends({
      manulifeName: "question_withcircle",
      fill: theme.colorPalette.primaryColors.main.shade_default,
      secondaryColor: theme.colorPalette.primaryColors.main.shade_default
    }, rest));
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    manulifeName: "question_withcircle_filled",
    fill: theme.colorPalette.neutralColors.light.shade_white,
    secondaryColor: theme.colorPalette.primaryColors.main.shade_dark_2
  }, rest));
};

process.env.NODE_ENV !== "production" ? DefaultIcon.propTypes = {
  variant: propTypes.oneOf([TOOLTIP_VARIANT.PRIMARY, TOOLTIP_VARIANT.SECONDARY]).isRequired,
  isShowTooltip: propTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  theme: propTypes.object.isRequired
} : void 0;
process.env.NODE_ENV !== "production" ? DefaultIcon.displayName = 'DefaultIcon' : void 0;

export default DefaultIcon;
